/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import Field from 'Component/Field';
import history from 'Util/History';

import { MyAccountCreateAccount as SourceMyAccountCreateAccount } from 'SourceComponent/MyAccountCreateAccount/MyAccountCreateAccount.component';

export class MyAccountCreateAccount extends SourceMyAccountCreateAccount {
    renderCreateAccountPersonalInfoFields() {
        const { isSubmitted } = this.props;
        const { location: { state: { firstName = '', lastName = '' } = {} } } = history;

        return (
            <fieldset block="MyAccountOverlay" elem="Legend">
                <Field
                  type="text"
                  label={ __('First Name') }
                  id="firstname"
                  name="firstname"
                  placeholder={ __('Your first name') }
                  value={ firstName }
                  autocomplete="given-name"
                  validation={ ['notEmpty'] }
                  validateSeparately
                  isSubmitted={ isSubmitted }
                />
                <Field
                  type="text"
                  label={ __('Last Name') }
                  id="lastname"
                  name="lastname"
                  placeholder={ __('Your last name') }
                  value={ lastName }
                  autocomplete="family-name"
                  validation={ ['notEmpty'] }
                  validateSeparately
                  isSubmitted={ isSubmitted }
                />
            </fieldset>
        );
    }

    renderCreateAccountSignUpInfoFields() {
        const { newsletterActive, isSubmitted } = this.props;
        const { location: { state: { email = '' } = {} } } = history;

        return (
            <fieldset block="MyAccountOverlay" elem="Legend">
                <Field
                  type="email"
                  label={ __('Email') }
                  id="email"
                  name="email"
                  placeholder={ __('Your email address') }
                  value={ email }
                  autocomplete="email"
                  validation={ ['notEmpty', 'email'] }
                  validateSeparately
                  isSubmitted={ isSubmitted }
                />
                <Field
                  type="password"
                  label={ __('Password') }
                  id="password"
                  name="password"
                  placeholder={ __('Enter your password') }
                  autocomplete="new-password"
                  validation={ ['notEmpty', 'password'] }
                  validateSeparately
                  isSubmitted={ isSubmitted }
                />
                <Field
                  type="password"
                  label={ __('Confirm password') }
                  id="confirm_password"
                  name="confirm_password"
                  placeholder={ __('Retype your password') }
                  autocomplete="new-password"
                  validation={ ['notEmpty', 'password', 'password_match'] }
                  validateSeparately
                  isSubmitted={ isSubmitted }
                />
                { this.renderVatNumberField() }
                { newsletterActive ? this.renderSubscribeToNewsletter() : null }
            </fieldset>
        );
    }
}

export default MyAccountCreateAccount;
